import React from "react";
import CustomTemplates from "../../Deals/CustomTemplate";
import { MicePage } from "../../../../components/template/CustomTemplate/Pages/MicePage";
import { MobileSafetyGuids } from "../../../../components/template/CustomTemplate/Pages/MobileSafetyGuids";

const SafetyPage = () => {
  
  return (
    <CustomTemplates slug={"mobile-safety-and-guides"} attributes={MobileSafetyGuids} />
  );
};

export default SafetyPage;
